var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDellLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 200,
    width: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fafafa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.006 10.807c-24.621 0-46.918 9.987-63.062 26.143-16.15 16.12-26.13 38.429-26.13 63.062 0 24.615 9.98 46.91 26.13 63.035 16.144 16.134 38.441 26.14 63.062 26.14 24.627 0 46.937-10.006 63.056-26.14 16.144-16.125 26.103-38.42 26.103-63.035 0-24.633-9.96-46.943-26.103-63.062-16.119-16.156-38.429-26.143-63.056-26.143m0-10.807C155.227 0 200 44.78 200 100.012 200 155.227 155.227 200 100.006 200 44.791 200 0 155.227 0 100.012 0 44.78 44.791 0 100.006 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71 99.197c0-5.827-3.866-9.138-9.34-9.138h-3.351v18.283h3.255c5.09 0 9.436-2.766 9.436-9.145m59.598 6.578l-24.682 19.436-22.559-17.76c-3.255 7.82-11.12 13.25-20.18 13.25H25.582V77.694h19.307c10.122 0 17.416 6.437 20.173 13.294l22.565-17.742 8.357 6.578-20.68 16.255 3.974 3.11 20.675-16.245 8.37 6.56-20.678 16.272 3.969 3.117 20.695-16.276V77.693h15.004v30.455h14.966v12.606h-29.97v-14.979zm48.975 2.38h14.96v12.599h-29.978v-43.06h15.018v30.46z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDellLogo);
export default __webpack_public_path__ + "static/media/dell-logo.a5615fc3f350e77e89ce171bbeba8b34.svg";
export { ForwardRef as ReactComponent };